import React from "react";

const PREVIEW_IMG = "https://customer-assets.emergentagent.com/job_pro-listings-6/artifacts/otdwmlpe_Screenshot%202026-04-24%20alle%2021.02.55.png";

/**
 * Informational banner shown inside the listing creation form.
 * No CTA to buy — just explains what the Home Spotlight boost is.
 * The actual purchase happens later from the dashboard.
 */
export default function BoostInfoBanner() {
  return (
    <div className="hm-card p-6 md:p-7 border-2 border-[#FFBE00]/40 bg-gradient-to-br from-[#FFBE00]/5 via-black to-[#E619A8]/5" data-testid="boost-info-banner">
      <div className="flex items-center gap-2 mb-3">
        <span className="inline-flex items-center gap-1.5 px-2 py-1 rounded bg-[#FFBE00] text-black text-[10px] font-bold uppercase tracking-wider">
          <i className="fas fa-bolt"></i> Home Spotlight
        </span>
        <span className="text-[10px] uppercase tracking-widest text-zinc-500">Info · opzionale</span>
      </div>
      <h3 className="font-heading font-black text-xl md:text-2xl leading-tight">
        Dopo la pubblicazione puoi mettere il tuo annuncio <span className="text-[#FFBE00]">in home page</span>.
      </h3>
      <p className="text-sm text-zinc-400 mt-2">
        Attivi il boost quando vuoi dalla <strong className="text-white">tua dashboard</strong>. Non serve sceglierlo adesso.
      </p>

      <div className="mt-5 grid md:grid-cols-[1.3fr_1fr] gap-5 items-center">
        {/* Preview screenshot */}
        <div className="rounded-xl overflow-hidden border border-zinc-800 bg-black">
          <img
            src={PREVIEW_IMG}
            alt="Anteprima sezione Annunci più visibili in home page"
            className="w-full h-auto block"
            loading="lazy"
          />
        </div>

        {/* How it works */}
        <div>
          <div className="text-xs uppercase tracking-widest text-[#FFBE00] mb-3">Come funziona</div>
          <ul className="space-y-3 text-sm">
            <li className="flex gap-3">
              <span className="flex-shrink-0 w-7 h-7 rounded-full bg-[#FFBE00] text-black font-black text-xs flex items-center justify-center">1</span>
              <span className="text-zinc-300"><strong className="text-white">Solo 8 slot</strong> visibili in home page — massima visibilità per pochi.</span>
            </li>
            <li className="flex gap-3">
              <span className="flex-shrink-0 w-7 h-7 rounded-full bg-[#FFBE00] text-black font-black text-xs flex items-center justify-center">2</span>
              <span className="text-zinc-300">Se sono pieni, entri in <strong className="text-white">waitlist</strong>: appena si libera un posto <strong className="text-white">ti arriva un'email automatica</strong> con il link per prenotarlo.</span>
            </li>
            <li className="flex gap-3">
              <span className="flex-shrink-0 w-7 h-7 rounded-full bg-[#FFBE00] text-black font-black text-xs flex items-center justify-center">3</span>
              <span className="text-zinc-300">Attivo per <strong className="text-white">30 giorni</strong> a <strong className="text-[#FFBE00]">€9,90</strong>. Reminder email 1 giorno prima della scadenza.</span>
            </li>
          </ul>
          <div className="mt-5 text-xs text-zinc-500 border-t border-zinc-900 pt-4">
            <i className="fas fa-info-circle mr-1 text-[#FFBE00]"></i>
            Per ora concentrati sul creare un annuncio di qualità. Il boost lo attivi dopo, con un click dalla dashboard.
          </div>
        </div>
      </div>
    </div>
  );
}
